import { useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import './select.css';

export default function SelectCompanie(){
  const { user, setCompanieUser, companiesSelected } = useContext(AuthContext);

  function changeCompanie(e){    
    setCompanieUser(e.target.value);
    window.location.reload();
  }

  return(
    <select className="companies" onChange={changeCompanie} value={localStorage.empresa}>
      {user.empresas.map((item, index) => (
        item.checked == true && <option key={index} value={item.id}>{item.razao_social}</option>
      ))}
    </select>  
  )
}